// ============================================================
//  CANONICALIZATION + LEGACY URL REDIRECTION
// ============================================================
//  - Forces every page to declare https://ichiandoripetcare.com
//    as its canonical (regardless of which host the visitor arrived on).
//  - Redirects legacy .php URLs (from the old WordPress/PHP site)
//    to their React-route equivalents so old backlinks don't 404.
// ============================================================

import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const CANONICAL_ORIGIN = 'https://ichiandoripetcare.com';

// Old .php URL → new React route
const LEGACY_REDIRECTS = {
  '/contact.php': '/contact',
  '/about.php': '/about',
  '/services.php': '/veterinary',
  '/gallery.php': '/gallery',
  '/index.php': '/',
  '/home.php': '/',
  '/book.php': '/book',
  '/appointment.php': '/book',
  '/veterinary.php': '/veterinary',
  '/grooming.php': '/grooming',
  '/boarding.php': '/boarding',
  '/retail.php': '/retail',
};

const setMetaContent = (selector, attr, value) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

const Canonicalizer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // 1) Legacy .php redirect (one-shot per navigation)
  useEffect(() => {
    const target = LEGACY_REDIRECTS[location.pathname.toLowerCase()];
    if (target && target !== location.pathname) {
      navigate(target + location.search + location.hash, { replace: true });
    }
  }, [location.pathname, location.search, location.hash, navigate]);

  // 2) Enforce canonical = ichiandoripetcare.com/<path> on every render
  useEffect(() => {
    const path = location.pathname === '/' ? '/' : location.pathname.replace(/\/+$/, '');
    const canonical = `${CANONICAL_ORIGIN}${path}`;
    setMetaContent('link[rel="canonical"]', 'href', canonical);
    // Keep OG/Twitter URLs aligned with the canonical so social shares are consistent
    setMetaContent('meta[property="og:url"]', 'content', canonical);
    setMetaContent('meta[property="twitter:url"]', 'content', canonical);
  }, [location.pathname]);

  return null;
};

export default Canonicalizer;
